$(window).on("load", function (e) {
  $(document).on("click", ".ctm_plus_btn", function (e) {
    e.preventDefault();
    $(this)
      .closest(".ajaxcart__row")
      .append(
        '<p class="Sorry! This product is Final Sale and limited to one per customer.</p>'
      );
    var _this = $(this);
    setTimeout(function (e) {
      _this.closest(".ajaxcart__row").find(".limitation_msg").remove();
    }, 5000);
    return false;
  });
});

$(document).on("keyup", "#faqInput", function (e) {
  e.preventDefault();
  $(this).addClass("");
  var len = $(this).val().length;
  if (len >= 3) {
    $("#suggestions").html("");
    myFunction();
    var html = $("#myUL").html();
    $("#suggestions").append(html);
  } else {
    if (len > 0) {
      $("#suggestions").html("");
      $("#suggestions").append(
        '<li><a href="javascript:void(0)">Please enter at least 3 letters and max of up to 128 letters</a></li>'
      );
    } else {
      $("#suggestions").html("");
    }
  }
});
$(document).on("click", "#suggestions li a", function (e) {
  e.preventDefault();
  var text = $(this).text();
  var id = $(this).data("index");
  if (
    $("#" + id)
      .find(".acc__title")
      .hasClass("active")
  ) {
  } else {
    $("#" + id)
      .find(".acc__title")
      .trigger("click");
  }
  $("#faqInput").val(text);
  setTimeout(function (e) {
    $("#suggestions").html("");
    $("html, body").animate(
      {
        scrollTop: $("#" + id).offset().top - 20,
      },
      1000
    );
  }, 100);
});

$(".dislike-ans").on("click", function (e) {
  $("body").addClass("loader_active");
  var _this = $(this);
  setTimeout(function (e) {
    _this.closest(".like-wrap").hide();
    _this.closest(".acc__panel").find(".feedbackResponse").show();
    $("body").removeClass("loader_active");
  }, 2000);
});

$(".like-ans").on("click", function (e) {
  $("body").addClass("loader_active");
  var _this = $(this);
  setTimeout(function (e) {
    _this.closest(".like-wrap").hide();
    _this.closest(".acc__panel").find(".feedbackResponse").show();
    $("body").removeClass("loader_active");
  }, 2000);
});

function myFunction() {
  var input, filter, ul, li, a, i, txtValue;
  input = document.getElementById("faqInput");
  filter = input.value.toUpperCase();
  ul = document.getElementById("myUL");
  li = $(ul).find("li");
  for (i = 0; i < li.length; i++) {
    a = li[i].getElementsByTagName("a")[0];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      li[i].style.display = "";
    } else {
      li[i].style.display = "none";
    }
  }
}
const ATCButton = document.getElementById("AddToCart");
let ATCButtonFlag = false;
let intervalId;

function ATCHandler(event) {
  event.preventDefault();
  if (window.customATCFlag) {
    ATCButton.removeEventListener("click", ATCHandler);
    if (intervalId) {
      clearInterval(intervalId);
    }
    return;
  }

  if (ATCButtonFlag) {
    return;
  }

  intervalId = setInterval(() => {
    ATCButton.click();
  }, 500);
  ATCButtonFlag = true;
}
if (ATCButton) {
  ATCButton.addEventListener("click", ATCHandler);
}

//Event Listener for closing the #CartDrawer
document.addEventListener("DOMContentLoaded", function () {
  const closeDrawer = () => {
    const body = document.body;
    if (
      !body.classList.contains("drawer-updating") &&
      !body.classList.contains("drawer--is-loading")
    ) {
      document.querySelector("#CartDrawer .js-drawer-close").click();
    }
  };
  const closeFloatingBtn = document.querySelector(
    "#CartDrawer .js-drawer-close-floating"
  );
  if (closeFloatingBtn) {
    closeFloatingBtn.addEventListener("click", closeDrawer);
    closeFloatingBtn.addEventListener("touchend", closeDrawer);
  }
  // Overlay click handler for cart drawer
  document
    .querySelector(".overlay_click")
    ?.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (
        timber.RightDrawer &&
        timber.RightDrawer.drawerIsOpen &&
        !timber.RightDrawer.isClosing
      ) {
        timber.RightDrawer.close();
      }
    });
});

// Zendesk Widget Configuration
function checkZendeskLoaded(callback) {
  if (typeof zE !== "undefined") {
    callback();
  } else {
    setTimeout(function () {
      checkZendeskLoaded(callback);
    }, 100);
  }
}

function initializeZendesk() {
  zE("webWidget", "hide");

  function openWidget() {
    zE("webWidget", "show");
    zE("webWidget", "open");
    const launcher = document.querySelector("#ctm_Launcher");
    if (launcher) {
      launcher.style.opacity = 0;
    }
  }

  zE("webWidget:on", "close", function () {
    zE("webWidget", "hide");
    const launcher = document.querySelector("#ctm_Launcher");
    if (launcher) {
      launcher.style.opacity = 1;
    }
  });

  window.openWidget = openWidget;
}

checkZendeskLoaded(initializeZendesk);

window.zESettings = {
  webWidget: {
    color: {
      theme: "#1B1C1E",
      button: "#FF600B",
      header: "#1B1C1E",
    },
    chat: {
      connectOnPageLoad: false,
      suppress: false,
      notifications: {
        mobile: {
          disable: true,
        },
      },
    },
  },
};

// Cookie Consent
if (window.cookieconsent) {
  window.cookieconsent.initialise({
    palette: {
      popup: { background: "#fff", text: "#000", link: "var(--orange)" },
      button: { background: "#000", border: "#000", text: "#fff" },
      highlight: { background: "var(--orange)", border: "var(--orange)" },
    },
    content: {
      href: "https://size.ca/pages/privacy-policy",
    },
    revokable: false,
    onStatusChange: function (status) {
      console.log(this.hasConsented() ? "enable cookies" : "disable cookies");
    },
    law: {
      regionalLaw: false,
    },
    location: true,
  });
}
